<template>
    <section class="charts">
        <highcharts class="chart" :options="lineOptions" ref="lineCharts"></highcharts>
    </section>
</template>
<script>
//import VueHighcharts from '../../src/VueHighcharts.vue'
//import * as data from '../assets/js/chartdata'
export default {
  components: {
   // VueHighcharts,
  },
  data() {
    return {
  //    lineOptions: data.basicData,
      lineOptions: {
        colors: ['#ffc107', '#c1c1c1', '#9e9e9e', '#80699B', '#3D96AE', '#DB843D', '#92A8CD', '#A47D7C', '#B5CA92'],
        chart: {
            type: 'spline'
        },
        title: {
            text: ''
        },
        subtitle: {
            text: ''
        },
        xAxis: {
            type: 'datetime'            
        },
        yAxis: {
            title: {
                text: 'mm/min'
            },
            labels: {
                formatter: function () {
                    return this.value + '';
                }
            }
        },
        tooltip: {
            crosshairs: true,
            shared: true
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            spline: {
                marker: {
                    radius: 4,
                    lineColor: '',
                    lineWidth: 1
                }
            }
        },
        series: [
            {
                name: 'Real Feed',
                marker: {
                    symbol: 'round',
                },
                data: []
            },
            {
                name: 'Simulation #1',
                marker: {
                    symbol: 'square'
                },
                data: []
            },
            {
                name: 'Simulation #2',
                marker: {
                    symbol: 'diamond'
                },
                data: []
            },
        ]
      },
      chartDataInterval:''
    }
  },
  created () {    
    //this.getChartData()
    this.randomChart()
  },
  beforeDestroy () {
    clearInterval(this.chartDataInterval)
  },
  methods: {
    getToday () {
      let toDay = new Date()
      new Date(toDay.setHours(toDay.getHours()+9))
      return toDay.toISOString().substring(0, 10)
    },
    randomRange(n1, n2) {
      return Math.floor( (Math.random() * (n2 - n1 + 1)) + n1 )
    },
    getChartData () {
        this.chartDataInterval = setInterval(() => {
          this.axios.get(`mod_getRealtime.php`)
            .then((result) => {
                let chart = this.$refs.lineCharts.chart
                let shift = chart.series[0].data.length > 30
                let realData = parseFloat(result.data[0].feedValue)
                let sim1Data = this.randomRange(1000,5000)
                let sim2Data = this.randomRange(1000,5000)
                let today = new Date()
                today.setHours(today.getHours() + 9)
                let time = today.getTime()
                let rPoint = [time, realData]
                let s1Point = [time, sim1Data]
                let s2Point = [time, sim2Data]
                chart.series[0].addPoint(rPoint, false, shift)
                chart.series[1].addPoint(s1Point, false, shift)
                chart.series[2].addPoint(s2Point, false, shift)

                chart.redraw()
                //console.log(result.data)
            })
          }, 1000)
    },
    randomChart () {
      this.chartDataInterval = setInterval(() => {
        let chart = this.$refs.lineCharts.chart
        let shift = chart.series[0].data.length > 30
        
        //console.log(chart)
        let realData = this.randomRange(1000,5000)
        let sim1Data = this.randomRange(1000,5000)
        let sim2Data = this.randomRange(1000,5000)
        let today = new Date()
        today.setHours(today.getHours() + 9)
        let time = today.getTime()
        let rPoint = [time, realData]
        let s1Point = [time, sim1Data]
        let s2Point = [time, sim2Data]
        chart.series[0].addPoint(rPoint, false, shift)
        chart.series[1].addPoint(s1Point, false, shift)
        chart.series[2].addPoint(s2Point, false, shift)

        chart.redraw()
        
      }, 1000)
    }
  }
}
</script>